export default class LaudoCusto {
  codLaudo = 0;
  qtdeHoraTecnica = 0;
  valorHoraTecnica = 0;
  fatorDeslocamento = 0;
  valorCombustivel = 0;
  descricaoOutrosCustos = "";
  valorOutrosCustos = 0;
  distancia = 0;
  valorTotalDeslocamento = 0;
  tipoCalculo = 0;
}
